// reducers.js

const initialState = {
  profile: [],
  roleId: null,
  menuId: null,
  menuSubid: null,
  cardId: null
}

const menuRightReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PROFILE':
      return {
        ...state,
        profile: action.payload
      }
    case 'SET_STATUS_ID':
      return {
        ...state,
        roleId: action.payload
      }
    case 'SET_MENU_ID':
      return {
        ...state,
        menuId: action.payload
      }
    case 'SET_SUBMENU_ID':
      return {
        ...state,
        menuSubid: action.payload
      }
    case 'SET_CARD_ID':
      return {
        ...state,
        cardId: action.payload
      }
    // case 'SET_SUBCARD_ID':
    //   return {
    //     ...state,
    //     sub_card: action.payload
    //   }
    default:
      return state
  }
}

export default menuRightReducer
